export const moneyFormat = (number, currency) => {
  return (
    Number(number)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&,') + (currency ? currency : ' SAR')
  )
}

export default moneyFormat

// Usage:
// numberFormat(15000) + ' SAR',

// Output:
// 15,000.00 SAR

// const currencyFormatter = (currency) => {
//   return new Intl.NumberFormat('en-US', {
//     style: 'currency',
//     currency: currency
//   })
// }

// const amountFormat = {
//   width: 180,
//   editable: true,
//   type: 'number',
//   valueFormatter: ({ value }) =>
//     currencyFormatter(this.state.currency).format(Number(value) / 3.75),
//   cellClassName: 'font-tabular-nums'
// }
